/* eslint-disable */
import { createStore } from 'vuex'

export const store = createStore( {
    
    state()
    {
        return {
            dbConnected:      false,
            uuid:             null,
            online:           false,
            authorized:       false,
            idSession:        false,
            idUser:           false,
            level:            0,
            username:         false,
            lastTick:         null,
            updateVersion:    false,
            autoLoginToken:   null,
            storeInitialized: false
        }
    },
    
    mutations: {
        
        setDatabase( state, value )
        {
            this.database = value
            state.dbConnected = true
        },
        
        setEventManager( state, value )
        {
            this.eventManager = value
        },
        
        setUuid( state, value )
        {
            state.uuid = value
            this.database.writeStorage( 'uuid', value )
        },
        
        setOnline( state, value )
        {
            state.online = value
        },
        
        setLevel( state, value )
        {
            state.level = value
        },
        
        setAuthorized( state, value )
        {
            state.authorized = value
            if ( true === value ) {
                window.authKey = this.getters.idSession
                this.eventManager.dispatch( 'on-auth-trigger' )
            }
            this.database.writeStorage( 'authorized', value )
        },
        
        setIdSession( state, value )
        {
            state.idSession = value
            this.database.writeStorage( 'idSession', value )
        },
        
        setIdUser( state, value )
        {
            state.idUser = value
            this.database.writeStorage( 'idUser', value )
        },
        
        setUsername( state, value )
        {
            state.username = value
            this.database.writeStorage( 'username', value )
        },
        
        setAutoLoginToken( state, value )
        {
            state.autoLoginToken = value
        },
        
        setLastTick( state, value )
        {
            state.lastTick = value
            this.database.writeStorage( 'lastTick', value )
        },
        
        setUpdateVersion( state, value )
        {
            state.updateVersion = value
        },
        
        setStoreInitialized( state, value )
        {
            state.storeInitialized = value
        },
        
        initStates()
        {
            
            let promises = []
            
            for ( const [ key, value ] of Object.entries( this.state ) ) {
                
                if ( 'dbConnected' !== key
                     && 'online' !== key ) {
                    
                    let todo = 'set' + key.charAt( 0 ).toUpperCase() + key.slice( 1 )
                    
                    promises.push( new Promise( resolve =>
                    {
                        
                        this.database.readStorage( key )
                            .then( result =>
                            {
                                
                                this.commit( todo, result )
                                return resolve()
                                
                            } )
                            .catch( () =>
                            {
                                this.commit( todo, value )
                                return resolve()
                            } )
                        
                    } ) )
                    
                }
                
            }
            
            Promise.all( promises )
                   .then( () =>
                   {
                       
                       if ( false !== this.getters.idSession
                            && this.getters.lastTick < ( Date.now() - ( 119 * 60000 ) ) ) {
                           this.commit( 'setIdSession', false )
                           setTimeout( () =>
                           {
                               this.eventManager.dispatch( 'on-session-timeout' )
                           }, 500 )
                       }
                       
                       this.eventManager.dispatchIndexed( 'on-store-initialized' )
                       this.eventManager.dispatch( 'after-store-init-states' )
                       this.commit( 'setStoreInitialized', true )
                       
                   } )
            
        }
        
    },
    
    getters: {
        
        dbConnected:      state => state.dbConnected,
        uuid:             state => state.uuid,
        online:           state => state.online,
        authorized:       state => state.authorized,
        idSession:        state => state.idSession,
        idUser:           state => state.idUser,
        level:            state => state.level,
        username:         state => state.username,
        lastTick:         state => state.lastTick,
        updateVersion:    state => state.updateVersion,
        autoLoginToken:   state => state.autoLoginToken,
        storeInitialized: state => state.storeInitialized
        
    },
    
    actions: {
        
        waitReady()
        {
            return new Promise( ( resolve ) =>
            {
                if ( this.getters.storeInitialized ) {
                    return resolve()
                } else {
                    setTimeout( () =>
                    {
                        return resolve( this.dispatch( 'waitReady' ) )
                    }, 300 )
                }
            } )
        },
        
        destroySession( { commit } )
        {
            return new Promise( ( resolve ) =>
            {
                
                commit( 'setAuthorized', false )
                commit( 'setIdSession', false )
                commit( 'setIdUser', false )
                commit( 'setUsername', false )
                commit( 'setUuid', null )
                commit( 'setLastTick', null )
                commit( 'setLevel', 0 )
                commit( 'setUpdateVersion', false )
                this.eventManager.dispatch( 'reset-all' )
                
                return resolve()
                
            } )
        },
        
        destroyStorage( { commit } )
        {
            return new Promise( ( resolve ) =>
            {
                
                commit( 'destroySession' )
                commit( 'setAutoLoginToken', null )
                this.eventManager.dispatch( 'reset-all' )
                
                return resolve()
                
            } )
        }
        
    }
    
} )